import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed,
  ref,
  watch,
  onMounted,
  nextTick,
} from 'vue'
import FormRulesFactory from '@/common/formRules'
import { ChargingTimeTariff } from '@/types/types'
import _ from 'lodash'

import { defineComponent, PropType } from 'vue'

const __default__ = defineComponent({
  name: 'PriceingPower',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  list: {
    type: Array as PropType<ChargingTimeTariff[]>,
    required: false,
    default: () => [],
  },
},
  emits: ['update:list'],
  setup(__props, { expose, emit }) {

const props = __props

const priceTariffElecFormRule = ref({
  // ...FormRulesFactory.generateCustomRules(['powerStart'], 'inputEmpty', 'inputInvalid', {
  //   pattern: /^\d+$/,
  //   maxDecimalPlaces: 2,
  // }),
  // ...FormRulesFactory.generateCustomRules(['powerEnd'], 'inputEmpty', 'inputInvalid', {
  //   pattern: /^\d+$/,
  //   maxDecimalPlaces: 2,
  // }),
  // ...FormRulesFactory.generateCustomRules(['price'], 'inputEmpty', 'inputInvalid', {
  //   pattern: /^\d+(\.\d{1,2})?$/,
  //   maxDecimalPlaces: 4,
  //   removeZeroCheck: true,
  // }),
  // ...FormRulesFactory.generateCustomRules(['servicePrice'], 'inputEmpty', 'inputInvalid', {
  //   pattern: /^\d+(\.\d{1,2})?$/,
  //   maxDecimalPlaces: 4,
  //   removeZeroCheck: true,
  // }),
})
const topicForm = ref()





const feeModel = ref<{ feeList: ChargingTimeTariff[] }>({
  feeList: [],
})

const feeList = computed<ChargingTimeTariff[]>({
  get: () => props.list,
  set: (val: any) => {
    emit('update:list', val)
  },
})
const vaildateValue = (inx: number) => {
  if (feeList.value[inx].price < 0) {
    feeList.value[inx].price = 0
  }
  if (feeList.value[inx].servicePrice < 0) {
    feeList.value[inx].servicePrice = 0
  }
}
const addPriceing = (obj: ChargingTimeTariff) => {
  let noneObj: ChargingTimeTariff = _.mapValues(obj, () => 0)
  feeList.value.push(noneObj)
}

const delPriceing = (row: ChargingTimeTariff) => {
  feeList.value.forEach((v, k) => {
    if (v === row) {
      feeList.value.splice(k, 1)
    }
  })
}

expose({
  validate: async () => {
    await nextTick()
    if (topicForm.value) {
      return topicForm.value.validate()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
  resetFields: async () => {
    await nextTick()
    if (topicForm.value) {
      topicForm.value.resetFields()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
  clearValidate: async () => {
    await nextTick()
    if (topicForm.value) {
      topicForm.value.clearValidate()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
})
watch(
  () => props.list,
  (newList) => {
    feeList.value = [...newList]
    feeModel.value.feeList = [...newList]
  },
  { immediate: true, deep: true }, // 立即执行，确保初始加载时也同步
)

onMounted(() => {
  // validateForm()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "topicForm",
    ref: topicForm,
    model: feeModel.value,
    "validate-on-rule-change": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: _unref(feeList),
        class: "shadow-none",
        "row-style": { height: '72px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Operation.priceingTariffPowerStart')
          }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.powerStart`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "number",
                    min: 0,
                    modelValue: row.powerStart,
                    "onUpdate:modelValue": ($event: any) => ((row.powerStart) = $event),
                    placeholder: "0"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Operation.priceingTariffPowerEnd')
          }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.powerEnd`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "number",
                    min: 0,
                    modelValue: row.powerEnd,
                    "onUpdate:modelValue": ($event: any) => ((row.powerEnd) = $event),
                    placeholder: "200"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Operation.priceingTariffPrice')
          }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.price`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    onChange: ($event: any) => (vaildateValue($index)),
                    type: "number",
                    min: 0,
                    modelValue: row.price,
                    "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                    placeholder: "0.20"
                  }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Operation.priceingTariffServicePrice')
          }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.servicePrice`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    onChange: ($event: any) => (vaildateValue($index)),
                    type: "number",
                    min: 0,
                    modelValue: row.servicePrice,
                    "onUpdate:modelValue": ($event: any) => ((row.servicePrice) = $event),
                    placeholder: "0.20"
                  }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, { width: "80" }, {
            header: _withCtx((_) => [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: ($event: any) => (addPriceing(_)),
                disabled: !_ctx.$hasPermission('post')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.add')), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ]),
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                disabled: !_ctx.$hasPermission('delete'),
                onClick: ($event: any) => (delPriceing(row)),
                style: { marginBottom: '8px' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})